const s = {
  name: "Hands01001",
  dimensions: { width: 26, height: 38 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 26 38" style="enable-background:new 0 0 26 38;" xml:space="preserve">
<style type="text/css">
	.st0{clip-path:url(#SVGID_00000061444707182435196810000010058536628228110250_);}
	.st1{fill: currentColor;}
</style>
<g>
	<defs>
		<rect id="SVGID_1_" width="26" height="38"/>
	</defs>
	<clipPath id="SVGID_00000046323060966717902880000017500880833837290138_">
		<use xlink:href="#SVGID_1_"  style="overflow:visible;"/>
	</clipPath>
	<g style="clip-path:url(#SVGID_00000046323060966717902880000017500880833837290138_);">
		<path class="st1" d="M8,4c0-2.2-1.8-4-4-4C1.8,0,0,1.8,0,4v21c0,7.2,5.8,13,13,13s13-5.8,13-13V8.4C26,6.1,24.3,4,22,4
			s-4,2.1-4,4.4v2.1c-0.6-0.3-1.3-0.5-2-0.5c-0.8,0-1.6,0.2-2.2,0.7C13.2,9.1,11.7,8,10,8C9.3,8,8.6,8.2,8,8.5V4z M4,2
			c1.1,0,2,0.9,2,2v13H4c-0.7,0-1.4,0.2-2,0.5V4C2,2.9,2.9,2,4,2z M10,17H8v-5c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2v5.5
			C11.4,17.2,10.7,17,10,17z M14,14c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2v7c0,1.1-0.9,2-2,2c-1.1,0-2-0.9-2-2V14z M13,23.6
			c0.7,0.8,1.8,1.4,3,1.4c2.2,0,4-1.8,4-4h2v-2h-2V8.4C20,7,21,6,22,6c1,0,2,1,2,2.4V25c0,6.1-4.9,11-11,11C6.9,36,2,31.1,2,25v-4
			c0-1.1,0.9-2,2-2h6c1.1,0,2,0.9,2,2s-0.9,2-2,2H6v2h4C11.2,25,12.3,24.5,13,23.6z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Hands01001
};
